import { render, staticRenderFns } from "./GroupJoinAuditDialog.vue?vue&type=template&id=0965fcfe&scoped=true"
import script from "./GroupJoinAuditDialog.vue?vue&type=script&lang=js"
export * from "./GroupJoinAuditDialog.vue?vue&type=script&lang=js"
import style0 from "./GroupJoinAuditDialog.vue?vue&type=style&index=0&id=0965fcfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0965fcfe",
  null
  
)

export default component.exports